import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./EmptyButton.module.scss";

export default function EmptyButton(props) {
  const { header, subHeader, buttonOnclick, buttonLabel } = props;

  return (
    <>
      <Grid2 className={styles.EmptyButton}>
        <Grid2>
          <Grid2 className={styles.header}>{header}</Grid2>
          <Grid2 className={styles.Subheader}>{subHeader}</Grid2>
        </Grid2>
        <Grid2 className={styles.buttonOnclick} onClick={buttonOnclick}>
          {buttonLabel}
        </Grid2>
      </Grid2>
    </>
  );
}
